import { FC } from 'react';
import { motion } from 'motion/react';
import { Button } from 'primereact/button';
import { ArrowRight } from 'lucide-react';

interface SubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
}

export const SubmitButton: FC<SubmitButtonProps> = ({ onClick, disabled, ariaLabel }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
    className="tw-absolute tw-top-[62.5%] tw-right-[100px]"
  >
    <Button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className="!tw-bg-white !tw-text-neutral-950 !tw-text-base !tw-font-bold !tw-rounded-full !tw-p-2.5 tw-shadow-md hover:tw-shadow-lg tw-transition-shadow focus:!tw-shadow-[0px_0px_0px_3px_rgba(163,163,163,0.50)] tw-outline tw-outline-2 focus:!tw-outline-4 tw-border-0 tw-outline-neutral-100 focus:!tw-outline-neutral-950/50 focus:!tw-border-neutral-950 focus:!tw-border-2 tw-inline-flex tw-justify-center tw-items-center tw-gap-2.5 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
    >
      <ArrowRight className="tw-w-4 tw-h-4" />
    </Button>
  </motion.div>
);
